import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '<',
        departments: '<',
        roles: '<',
        levels: '<',
        context: '=',
        canManageCourse: '='
    },
    template: `
        <div class="loader02" ng-if="vm.loading"></div>
        <alert-error ng-if="vm.form.errors.courseIsArchived">{{ 'general.There were errors processing the form' | translate }}</alert-error>
        <div class="open" ng-class="{block02: vm.TokenService.isOptionalCoursesModuleEnabled()}">
            <div class="heading01 heading01b">
                <h3 ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">{{ 'courses.Compulsory targets' | translate }}</h3>
                <a class="btn add" ng-if="vm.canManageCourse" ng-click="vm.manageTarget(null, vm.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY)">{{ 'courses.Add target' | translate }}</a>
            </div>
            <div class="loader01" ng-if="!vm.course"></div>
            <courses-courses-steps-target-list
                 can-manage-course="vm.canManageCourse"
                 targets="vm.compulsoryTargets"
             />
        </div>
        <div ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()" class="open block02">
            <div class="heading01 heading01b">
                <h3>{{ 'courses.Optional targets' | translate }}</h3>
                <a class="btn add" ng-if="vm.canManageCourse" ng-click="vm.manageTarget(null, vm.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.OPTIONAL)">{{ 'courses.Add target' | translate }}</a>
            </div>
            <div class="loader01" ng-if="!vm.course"></div>
            <courses-courses-steps-target-list
                 can-manage-course="vm.canManageCourse"
                 targets="vm.optionalTargets"
                 is-optional="true"
             />
        </div>
        <div ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()" class="block02 open">
            <div class="heading01 heading01b">
                <h3>{{ 'courses.Exceptions' | translate }}</h3>
            <a class="btn add" ng-if="vm.canManageCourse" ng-click="vm.addExceptionTarget()">{{ 'courses.Add rule' | translate }}</a>
            </div>
            <div class="tablewrapper">
                <div class="loader01" ng-if="!vm.course"></div>
                <list-empty list="vm.exceptionTargets" show-add-message="true"></list-empty>
                <table class="data01 col-4" datatable dt-options="vm.DATATABLES" ng-if="vm.exceptionTargets.length">
                    <thead>
                    <tr>
                        <th>{{ 'employee.First Name' | translate }}</th>
                        <th>{{ 'employee.Last Name' | translate }}</th>
                        <th>{{ 'employee.Position' | translate }}</th>
                        <th>{{ 'courses.Need' | translate }}</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-repeat="drl in vm.exceptionTargets">
                        <td>{{ drl.employee.firstName }}</td>
                        <td>{{ drl.employee.lastName }}</td>
                        <td>
                            <p ng-repeat="employeeDrl in drl.employee.drlsWithValue">
                                {{ employeeDrl.departmentName }}, {{ employeeDrl.roleName }}, {{ employeeDrl.levelName }}
                            </p>
                        </td>
                        <td>
                            {{ vm.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.LABELS[drl.type] }}
                        </td>
                        <td class="actions">
                            <a class="btn edit"
                                ng-if="vm.canManageCourse"
                                ng-click="vm.manageExceptionTarget(drl)"
                            >{{ 'general.Edit' | translate }}</a>
                            <a class="btn delete"
                                ng-if="vm.canManageCourse"
                                ng-click="vm.removeDrl(drl.id, true)"
                            >{{ 'general.Remove' | translate }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    <ul class="actions01">
        <li class="primary">
            <a
                ng-if="vm.canManageCourse && !vm.course.isArchived"
                ng-click="vm.save()"
                class="btn main"
                ng-disabled="vm.saveLoading"
                ng-class="{'loading': vm.saveLoading}"
            >
                <span ng-if="vm.context==='edit'">{{ 'general.Save' | translate }}</span>
                <span ng-if="vm.context==='add'">{{ 'general.Next' | translate }}</span>
            </a>
        </li>
        <li>
            <a ui-sref="authorized.courses.courses.list()" class="btn discrete" >
                <span ng-if="vm.context==='edit'">{{ 'general.Back to list' | translate }}</span>
                <span ng-if="vm.context==='add'">{{ 'general.Cancel' | translate }}</span>
            </a>
        </li>
    </ul>
    <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
    `
})

export default class {

    constructor ($state, $translate, lodash, toastr, DATATABLES, FormFactory, Upload,
                 TokenService, ModalService, CourseResource, CourseService, PrivilegeService, UserResource,
                 COURSE_TARGET_NEED_TYPE_ENUM, COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM, COURSE_TRAINING_ORDER_TYPE_ENUM) {
        this.DATATABLES = DATATABLES;
        this.FormFactory = FormFactory;
        this.Upload = Upload;
        this.ModalService = ModalService;
        this.CourseResource = CourseResource;
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.CourseService = CourseService;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.UserResource = UserResource;
        CourseService.nestCompositeModels(this.course);
        this.loading = false;
        this.saveLoading = false;
    }

    $onInit () {
        this.loadDefaultTargets();
        this.loadExceptionTargets();
        this.courseDrlUsers = [];
        this.loadPlanningGroupUsers();
    }

    loadPlanningGroupUsers () {
        this.UserResource.query({ drlCourseId: this.course.id, planningGroupsUser: true }).$promise
            .then(courseDrlUsers => {
                this.courseDrlUsers = courseDrlUsers;
            });
    }

    manageTarget (id, preselectedNeedType = null) {
        const { departments, roles, levels, course, courseDrlUsers } = this;
        this.reloadCourse(); // to avoid cached error values

        return this.ModalService.open({
            size: id ? 'medium' : 'large',
            template: `
                <modals-courses-drl-add
                    ng-if="!vm.drlId"
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    course="vm.course"
                    preselected-need-type="vm.preselectedNeedType"
                />
                <modals-courses-drl-edit
                    ng-if="vm.drlId"
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    course="vm.course"
                    drl-id="vm.drlId"
                    course-drl-users="vm.courseDrlUsers"
                />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.course = course;
                this.drlId = id;
                this.courseDrlUsers = courseDrlUsers;
                this.preselectedNeedType = preselectedNeedType;
            }
        })
            .then(() => {
                this.loadPlanningGroupUsers();
                this.reloadCourse();
            });
    }

    manageExceptionTarget (drl) {
        const { departments, roles, levels, course } = this;
        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-courses-drl-edit
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    course="vm.course"
                    drl-id="vm.drl.id"
                    employee-drl="vm.drl"
                />
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.course = course;
                this.drl = drl;
            }
        })
            .then(() => {
                this.reloadCourse();
            });
    }

    addExceptionTarget () {
        const { departments, roles, levels, course, exceptionTargets } = this;
        this.reloadCourse(); // to avoid cached error values

        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-courses-target-exception-add
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    course="vm.course"
                    exception-targets="vm.exceptionTargets"
                />
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.course = course;
                this.exceptionTargets = exceptionTargets;
            }
        })
            .then(() => {
                this.reloadCourse();
            });
    }

    removeDrl (drlId, isException = false, isOptional = false) {
        let message = this.$translate.instant('course.confirm_before_deleting_drl');
        if (isException) {
            message = this.$translate.instant('course.confirm_before_deleting_exception_drl');
        }
        else if (!isOptional) {
            message = this.$translate.instant('course.confirm_before_deleting_compulsory_drl');
        }

        return this.ModalService.delete(message)
            .then(() => {
                this.loading = true;
                this.initForm(drlId);
                this.form.save()
                    .then(() => {
                        this.toastr.success(this.$translate.instant('course.Target deleted'));
                        this.reloadCourse();
                    }).finally(() => {
                        this.loading = false;
                    });
            });
    }

    initForm (drlId) {
        this.form = this.FormFactory.create(this.course, model => model.$update({ id: model.id }));

        if (this.form.model.expirationMonths === null) {
            this.form.model.expirationMonths = 0;
        }

        this.form.model.courseTargets = angular.copy(this.lodash.filter(this.course.courseTargetsWithValue, (drl) => {
            return drl.id !== drlId;
        }));

        this.form.model.fields = this.course.courseFields.map((field) => (field.fieldId));
        this.form.model.courseSiteIds = this.course.sites.map(site => (site.id));
    }

    reloadCourse () {
        this.CourseResource.get({ id: this.course.id,
            expand: 'courseFields,courseTrainings,activeI18n,courseTargetsWithValue.employee.drlsWithValue,courseI18ns,courseTrainingI18ns,sites,planningGroups.planningGroupTargets'
        })
        .$promise.then((reloadedCourse) => {
            this.CourseService.nestCompositeModels(reloadedCourse);
            this.course = reloadedCourse;
            this.loadDefaultTargets();
            this.loadExceptionTargets();
        });
    }

    loadDefaultTargets () {
        this.defaultTargets = this.course.courseTargetsWithValue.filter((courseTarget) => {
            return !courseTarget.employeeId;
        });
        this.compulsoryTargets = this.course.courseTargetsWithValue.filter((courseTarget) => {
            return !courseTarget.employeeId && courseTarget.type === this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.KEYS.COMPULSORY;
        });
        this.optionalTargets = this.course.courseTargetsWithValue.filter((courseTarget) => {
            return !courseTarget.employeeId && courseTarget.type === this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.KEYS.OPTIONAL;
        });
    }

    loadExceptionTargets () {
        this.exceptionTargets = this.course.courseTargetsWithValue.filter((courseTarget) => courseTarget.employeeId);
    }

    save () {
        this.saveLoading = true;
        if (this.context === 'add') {
            this.createVersion().then(response => {
                this.$state.go('authorized.courses.courses.edit.version.edit.training', {
                    id: this.course.id,
                    versionId: response.data.id
                });
            }).catch(() => {
                this.$state.go('authorized.courses.courses.edit.occurrence.list', { id: this.course.id });
            });
        }
        else {
            this.$state.go('authorized.courses.courses.edit.occurrence.list', { id: this.course.id });
        }
    }

    createVersion () {
        const uploadUrl = `${SEED_CORE.ENV.API_URL}course/version`;
        const method = 'POST';

        const versionModel = {
            name: 'Version 1',
            courseId: this.course.id,
            trainingOrderType: this.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.SEQUENCE
        };

        return this.Upload.upload({
            url: uploadUrl,
            method,
            data: versionModel
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/target/index.js